package com.example.mystybag.appCore.views.pages

import androidx.compose.runtime.Composable
import com.example.mystybag.appCore.logic.pages.BagsViewModel

@Composable
fun BagsWebView(viewModel: BagsViewModel) {
    ComingSoonWebView()
}
